<template>
    <v-main class="lyt-container pt-3 justify-center custom-main">
        <v-container>
            <v-row class="d-flex justify-center white--text">
                <v-img
                    :src="require('../assets/icn_voto_mesas_white.svg')"
                    max-height="3rem"
                    max-width="3rem"
                ></v-img>
                <h1>Mesas de votación</h1>
            </v-row>
            <v-row class="d-flex justify-center mt-4 table-admins">
                <v-data-table
                    class="datatable-admins"
                    :headers="headers"
                    :items="mesas"
                    :search="search"
                >
                    <template v-slot:top>
                        <v-select
                            :items="elecciones"
                            :item-text="textItemElection"
                            class="mx-4"
                            item-value="id"
                            label="Selecciona elección"
                            v-model="electionIdSelected"
                            @change="onChangeElection"
                            :loading="isLoading"
                        >
                        </v-select>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-list-item>
                            <v-list-item-action>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            :disabled="
                                                isLoading ||
                                                    !item.cierre_file_url
                                            "
                                            icon
                                            @click="
                                                openActaFirmada(
                                                    item.cierre_file_url
                                                )
                                            "
                                            :color="
                                                item.cierre_file_url
                                                    ? '#01579b'
                                                    : ''
                                            "
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <i class="fa fa-box"></i>
                                        </v-btn>
                                    </template>
                                    <span>Descargar acta de cierre</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </v-data-table>
            </v-row>
        </v-container>
    </v-main>
</template>
<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import api from '@/api';

export default {
    components: {
        ScaleLoader,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Escuela / División',
                    value: 'desc_ures',
                },
                {
                    text: 'Consejo',
                    value: 'desc_ocg',
                },
                {
                    text: 'Nº Mesa',
                    value: 'no_mesa',
                },
                {
                    text: 'Actas',
                    value: 'actions',
                    sortable: false,
                },
            ],
            search: '',
            electionIdSelected: '',
            isLoading: false,
            elecciones: [],
            mesas: [],
        };
    },
    methods: {
        onChangeElection() {
            this.loadTables();
        },
        loadElections() {
            this.isLoading = true;
            this.elecciones = [];
            api.get('get-elections-public')
                .then(res => {
                    if(res.data){
                        this.elecciones = res.data;
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        openActaFirmada(url) {
            if (!url) return;
            window.open(url, '_blank');
        },
        loadTables() {
            this.isLoading = true;
            if (this.electionIdSelected == '') return;
            const election = this.elecciones.find(
                election => election.id === this.electionIdSelected
            );
            this.mesas = [];
            api.post(`get-tables-public`, {
                election_id: election.id,
                type: election.type,
            })
                .then(res => {
                    if(res.data){
                        this.mesas = res.data;
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        textItemElection: item =>
            `${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this.loadElections();
    },
};
</script>
<style lang="scss">
.lyt-container {
    background-image: url('../assets/bg_udg.png');
    background-color: $votex-background-primary;
}

.table-admins {
    margin-bottom: 100px;
    .datatable-admins {
        width: 100%;
    }
}
</style>
